module.exports = __webpack_public_path__ + "static/media/star.11a8569e.svg";